import {
  Directive,
  ElementRef,
  Input,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[setPositionByIndex]',
  standalone: true,
})
export class SetPositionByIndexDirective {
  @Input() setPositionByIndex: number;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.setPositionByIndex !== null) {
      const position = this.setPositionByIndex > 5 ? 'left' : 'right';
      this.renderer.setAttribute(this.el.nativeElement, 'position', position);
    }
  }
}
